<template>
  <section class="hbox stretch">
    <div class="content-header">      
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item><a href="/">店铺</a></el-breadcrumb-item>
        <el-breadcrumb-item>库存</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-main">
      <el-form :inline="true" size="medium">            
        <el-form-item>
          <el-button type="primary" class="el-icon-circle-plus-outline" v-on:click="Add" >新增</el-button>
        </el-form-item>
        <el-form-item >
          <el-input  placeholder="名称" v-model="name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="Search" >查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="rows" style="width: 100%">
        <el-table-column  fixed  prop="Name"  label="名称" > </el-table-column>
        <el-table-column  fixed  prop="Skus"  label="规格" > </el-table-column>
        <el-table-column  fixed  prop="StoreName"  label="所属门店" > </el-table-column>
        <el-table-column  fixed  prop="Number"  label="数量" > </el-table-column>
        <el-table-column  fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button @click.native.prevent="Edit(scope.row)" type="text" size="small">
            编辑
          </el-button>
        </template>
      </el-table-column>
      </el-table>
      <el-pagination
        :hide-on-single-page="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>
    <dia v-bind:dialog="dialog" ></dia>
  </section>
</template>
<script  type='text/ecmascript-6'>
  import dia from './purchase'
  export default {
    data (){
      return {
        name:'',
        pageIndex:1,
        pagesize:10,
        totalCount:0,
        sort:'Id desc',
        rows:[],
        dialog: {
          id:'0',
          title: '',
          isShow:false
        }
      }
    },
    components:{    
      dia
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.pageIndex = 1;
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/ProductStock/index',
          params:{
            name : that.name,
            pageIndex : that.pageIndex,
            pagesize : that.pagesize,
            sort : that.sort
          }
        }).then(function (resp) {
          that.totalCount = resp.data.totalCount
          that.rows = resp.data.data
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      Add:function(){
        this.dialog.id = '0'
        this.dialog.title = '进货'
        this.dialog.isShow = true
      },
      Edit(row){
        this.dialog.id = row.Id
        this.dialog.title = '库存变动'
        this.dialog.isShow = true 
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      }
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
.map
  width: 100%;
  height: 200px;
</style>